import { createTheme } from "@mui/material/styles";
import uiConfig from "../config/uiConfig";


const lightTheme = createTheme({

  palette: {

    mode: "light",

    background: {

      default: "#f8fafc",

      paper: "#ffffff",

    },


    primary: {

      main: uiConfig.buttonColor,

    },


    text: {

      primary:"#0f172a",

      secondary:"#64748b",

    },


    divider:"#e5e7eb",

  },



  typography: {

    fontFamily:
    "Inter, Roboto, Arial",

  },



  components: {


    MuiCard: {

      styleOverrides: {

        root: {

          background:"#ffffff",

          border:"1px solid #e5e7eb",

          borderRadius:"12px",

          boxShadow:"0 2px 8px rgba(0,0,0,0.05)",

        }

      }

    },



    MuiPaper: {

      styleOverrides: {

        root: {

          background:"#ffffff",

        }

      }

    },



    MuiTableCell: {

      styleOverrides: {

        root: {

          color:"#0f172a",

          borderBottom:"1px solid #e5e7eb",

        }

      }

    }

  }


});


export default lightTheme;